<template>
	<div class="import">
        <v-btn @click="importSlots">Import</v-btn>
    </div>      
</template>
<script>
import firebase from 'firebase'
import db from '../firestore'
export default {
data () {
    return {
        dialog: false,
        slots:[
            {
                "date": "2020-09-07",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "gas_law",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "gas_law",
                "set_id": "set_1",
                "assign_to": null
            },
            
            {
                "date": "2020-09-07",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "em",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "em",
                "set_id": "set_1",
                "assign_to": null
            },
            
            {
                "date": "2020-09-07",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "env",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "env",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "gas_law_200",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-09-07",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-09-14",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-09-21",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-09-28",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-05",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-12",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-10-19",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-10-26",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-02",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-09",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-16",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-23",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-11-30",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "acc",
                "set_id": "set_0",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "acc",
                "set_id": "set_1",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "acc",
                "set_id": "set_2",
                "assign_to": null
            },
            {
                "date": "2020-12-07",
                "experiment_id": "acc",
                "set_id": "set_3",
                "assign_to": null
            }
        ]
    }
},
mounted(){
    var self = this;
},
methods:{
    importSlots() {
        var self = this;
        var batch = db.batch();
        self.slots.forEach((doc) => {
            var docRef = db.collection("slots").doc(); //automatically generate unique id
            batch.set(docRef, doc);
        });
        batch.commit()
        .then(() => {
            console.log("Import success!");
        })
        .catch((error) => {
            console.error("Error writing document: ", error);
        });
    },
    }
}
</script>

<style>

</style>
